import styled from 'styled-components';

export const TooltipWrapper = styled.div`
  color: ${({ theme }) => theme.colors.label};
`;
